import SearchableSelect from './SearchableSelect';
import { clientDisplayLabel, clientSearchText } from './entitySearchLabels';

export default function SearchableClientSelect({
  clients = [],
  value,
  onChange,
  placeholder = 'Search by name, email, phone, or ID…',
  allowEmpty = false,
  emptyLabel = '',
  compact = false,
  showHint = true,
  className = ''
}) {
  return (
    <SearchableSelect
      items={clients}
      value={value}
      onChange={onChange}
      getValue={c => c.id}
      getLabel={clientDisplayLabel}
      getSearchText={clientSearchText}
      placeholder={placeholder}
      hint="Search by name, email, phone, or ID — list shows client name"
      showHint={showHint && !compact}
      allowEmpty={allowEmpty}
      emptyLabel={emptyLabel}
      compact={compact}
      className={className}
      clearAriaLabel="Clear client"
    />
  );
}
